import * as React from 'react';
import { IconProps } from './icon-props';

const CheckmarkIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="6"
    fill="none"
    viewBox="0 0 9 6"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m1.5 3 2 2 4-4"
    ></path>
  </svg>
);

export default CheckmarkIcon;
